import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges, ViewChild, inject } from '@angular/core';
import { Product } from '../../../catalog/product/product.decorator';
import { ReviewsIOService } from '../reviews-io.service';

@Component({
    selector: 'reviews-io-rating',
    template: ` <div class="pe-none"><div #snippetContainer class="ruk_rating_snippet" [attr.data-sku]="productsSKUs"></div></div>`,
    standalone: true
})
export class ReviewsIORatingComponent implements OnChanges, AfterViewInit {
    @Input({ required: true })
    product!: Product;

    @Input()
    showRatingText = true;

    @ViewChild('snippetContainer')
    snippetContainer?: HTMLElement;

    private reviewsIOService = inject(ReviewsIOService);

    constructor(private ref: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.reviewsIOService.updateRatingText(this.showRatingText);
    }

    ngAfterViewInit(): void {
        this.reviewsIOService.throttledUpdateRatingSnippet();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['product'] && this.snippetContainer) {
            this.ref.detectChanges(); // update sku attr in template
            this.reviewsIOService.throttledUpdateRatingSnippet();
        }
    }

    get productsSKUs(): string {
        return this.reviewsIOService.getProductsSKUs(this.product);
    }
}
